import {
  AiAssistantChatHistory,
  AiAssistantChatHistoryItem,
  AiAssistantChatMessageAuthor,
} from "types/aiAssistant/chatHistory";
import {
  AI_ASSISTANT_CHAT_HISTORY_LOCAL_STORAGE_KEY,
  AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY,
} from "constants/aiAssistant";

export const getAiAssistantChatHistory = (): AiAssistantChatHistory => {
  const chatHistory = localStorage.getItem(AI_ASSISTANT_CHAT_HISTORY_LOCAL_STORAGE_KEY);
  return chatHistory ? JSON.parse(chatHistory) : [];
};

const setAiAssistantChatHistory = (chatHistory: AiAssistantChatHistory) => {
  localStorage.setItem(AI_ASSISTANT_CHAT_HISTORY_LOCAL_STORAGE_KEY, JSON.stringify(chatHistory));
};

export const addAiAssistantChatHistoryItem = (items: AiAssistantChatHistoryItem[]) => {
  const chatHistory = getAiAssistantChatHistory();
  chatHistory.push(...items);
  setAiAssistantChatHistory(chatHistory);
};

export const clearAiAssistantChatHistory = () => {
  localStorage.removeItem(AI_ASSISTANT_CHAT_HISTORY_LOCAL_STORAGE_KEY);
};

export const getAiAssistantChatId = (): string | null => {
  const chatId = localStorage.getItem(AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY);
  return chatId || null;
};

export const setAiAssistantChatId = (chatId: string | null) => {
  if (chatId) {
    localStorage.setItem(AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY, chatId);
  } else {
    localStorage.removeItem(AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY);
  }
};

export const clearAiAssistantChatId = () => {
  localStorage.removeItem(AI_ASSISTANT_CHAT_ID_LOCAL_STORAGE_KEY);
};

export const clearAiAssistantData = () => {
  clearAiAssistantChatHistory();
  clearAiAssistantChatId();
};

export const createAiAssistantChatHistoryItem = (
  message: string,
  author: AiAssistantChatMessageAuthor,
) => {
  return { message, author, timestamp: new Date().toISOString() };
};
